import { render, staticRenderFns } from "./IndexDialog.vue?vue&type=template&id=4c66bd93&scoped=true"
import script from "./IndexDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IndexDialog.vue?vue&type=style&index=0&id=4c66bd93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66bd93",
  null
  
)

export default component.exports